module.exports = __webpack_public_path__ + "img/7.04fec7b9.webp";